// This file serves as a central export point for all assets used in the application.

// assets for profile screen
// assets for sidebar
import AdsModalBackground from './adsModal/ads_modal_background.png';
import AdsModalChips from './adsModal/ads_modal_chips.png';
//assets for ranking table
import AdsModalWatchButton from './adsModal/ads_modal_watch_button.png';
import WatchAddsButton from './adsModal/watch_ads_button.png';
//assets for modal
import MyTablesButtonBg from './appFooter/myTablesButtonBg.png';
import TournamentsButtonBg from './appFooter/tournamentsButtonBg.png';
import BGCollectBtn from './bonusGames/BGCollectBtn.png';
import BGCollectBtnMobile from './bonusGames/BGCollectBtnMobile.svg';
import BGCollectBtnWrapper from './bonusGames/BGCollectBtnWrapper.png';
import BGCurrentDayFrame from './bonusGames/BGCurrentDayFrame.png';
import BGCurrentDayFrameMobile from './bonusGames/BGCurrentDayFrameMobile.png';
import BGDay1 from './bonusGames/BGDay1.png';
import BGDay2 from './bonusGames/BGDay2.png';
import BGDay3 from './bonusGames/BGDay3.png';
import BGDay4 from './bonusGames/BGDay4.png';
import BGDay5 from './bonusGames/BGDay5.png';
import BGHorDivider from './bonusGames/BGHorDivider.png';
import BGHorDividerAndTrMobile from './bonusGames/BGHorDividerAndTrMobile.png';
import BGHorDividerMobile from './bonusGames/BGHorDividerMobile.png';
import BGPlayBtn from './bonusGames/BGPlayBtn.png';
import BGRegularDayFrame from './bonusGames/BGRegularDayFrame.png';
import BGRorB from './bonusGames/BGRorB.png';
import BGRorB_Thumb from './bonusGames/BGRorB_Thumb.png';
import BGScratch from './bonusGames/BGScratch.png';
import BGScratch_Thumb from './bonusGames/BGScratch_Thumb.png';
import BGSlot from './bonusGames/BGSlot.png';
import BGSlot_Thumb from './bonusGames/BGSlot_Thumb.png';
import BGTimerWrapper from './bonusGames/BGTimerWrapper.png';
import BGVertDividerMobile from './bonusGames/BGVertDividerMobile.png';
import BonusGInfoBtn from './bonusGames/BonusGInfoBtn.png';
//assets for bonus games modal
import BonusGJackpot from './bonusGames/BonusGJackpot.png';
import BonusGLogo from './bonusGames/BonusGLogo.png';
import JackpotCoin from './bonusGames/Coins.png';
import JackpotHistory from './bonusGames/history.png';
import BonusesHover from './bottom/BonusesHover.png';
// assets for bottom navigation
import BottomPng from './bottom/bottom.png';
import BottomJackpot from './bottom/bottomJakcpotBckd.png';
import BottomlPng from './bottom/bottoml.png';
import BtnBottomBonusesPng from './bottom/btn_bonuses.png';
import BtnBottomBonusesCollectPng from './bottom/btn_bonuses_collect.png';
import BtnBottomBonusesCollectLightPng from './bottom/btn_bonuses_collect_light.png';
import BtnBottomLobbyPng from './bottom/btn_lobby.png';
import BtnBottomRankingPng from './bottom/btn_ranking.png';
import BtnBonuses from './bottom/btnBonuses.png';
import BtnLobby from './bottom/btnLobby.png';
import BtnRanking from './bottom/btnRanking.png';
import JackpotCoins from './bottom/coins.png';
import BottomLightDownPng from './bottom/lightDown.png';
import BottomLightUpPng from './bottom/lightUp.png';
import BgFlag from './buttonsByLanguage/flags/bg_flag.png';
import EnFlag from './buttonsByLanguage/flags/en_flag.png';
import FrFlag from './buttonsByLanguage/flags/fr_flag.png';
import RuFlag from './buttonsByLanguage/flags/ru_flag.png';
import TrFlag from './buttonsByLanguage/flags/tr_flag.png';
import CarouselCardBgPng from './carousel/BG_.png';
import LeftArrowPng from './carousel/leftArrow.png';
import RightArrowPng from './carousel/rightArrow.png';
import CarouselCardGlowPng from './carousel/texture_glow_one_layer.png';
import JackpotChipPng from './chip.png';
import CityBackground from './cities/citybckgd.png';
import LondonPng from './cities/london.png';
import MacaoPng from './cities/macao.png';
import MonacoPng from './cities/monaco.png';
import ParisPng from './cities/paris.png';
import SofiaPng from './cities/sofia.png';
import VegasPng from './cities/vegas.png';
import VipPng from './cities/vip.png';
import BonusBgPng from './dailyBonus/bonus_bg.png';
import BonusBgPortraitPng from './dailyBonus/bonus_bg_portrait.png';
import BonusRedBlackGif from './dailyBonus/bonus_red_black.gif';
import BonusScratchGif from './dailyBonus/bonus_scratch.gif';
import BonusSlotGif from './dailyBonus/bonus_slot.gif';
import DailyBonusBgGif from './dailyBonus/daily_bonus_bg.gif';
import DailyBonusEnGif from './dailyBonus/daily_bonus_en.gif';
import DailyBonusFrGif from './dailyBonus/daily_bonus_fr.gif';
import DailyBonusRuGif from './dailyBonus/daily_bonus_ru.gif';
import DailyBonusTextBgPng from './dailyBonus/daily_bonus_text_bg.png';
import DailyBonusTextEnPng from './dailyBonus/daily_bonus_text_en.png';
import DailyBonusTextFrPng from './dailyBonus/daily_bonus_text_fr.png';
import DailyBonusTextRuPng from './dailyBonus/daily_bonus_text_ru.png';
import PlayerIconPng from './header/player-icon.png';
import CityPng from './lobby/city.png';
import LightsLevels from './lobby/lightslevels.png';
import TablesContainerPng from './lobby/tablesContainer.png';
import BlueTable from './lobbyTable/blue.png';
import LobbyTableChip from './lobbyTable/lobbyTableChip.png';
import PlayerGold from './lobbyTable/PlayerGold.png';
import PlayerGrey from './lobbyTable/playerGrey.png';
import Table from './lobbyTable/Table.png';
import AppleButton from './login/Apple.png';
import LanguageCaret from './login/caret.png';
import LanguageCaretUp from './login/caretUp.png';
import FacebookButton from './login/FacebookButton.png';
import GoogleButton from './login/GoogleButton.png';
import HorizontalLoginBg from './login/horizontal-login-bg.png';
import PortraitLoginBg from './login/portrait-login-bg.png';
import LogoAnimation from './logo_animated/logo_3_card_poker.png';
import BgLandscapePng from './main/bg-landscape.png';
import BgPortraitPng from './main/bg-portrait.png';
import BgTournament from './main/bg-tournament.png';
import BgTournamentMobile from './main/bg-tournament-portrait.png';
import BottomStripPng from './main/common/BottomStrip.png';
import BottomStripRightPng from './main/common/BottomStripRight.png';
// common assets for main screen
import BtnMainBackground from './main/common/btn_background.png';
import MainUserIcon from './main/common/user.png';
import MainUsersLiveFramePng from './main/common/usersLiveFrame.png';
import LogoPng from './main/logo.png';
import BtnMainPlayNowPng from './main/playNowBtn/play.png';
import TitleMainPlayNowPng from './main/playNowBtn/title_play_now.png';
import BtnMainTournamentsPng from './main/tournamentsBtn/btn_tournaments.png';
import TitleMainTournamentsPng from './main/tournamentsBtn/title_tournaments.png';
import BtnMainVipPng from './main/vipButton/btn_vip.png';
// assets for main screen buttons
import TitleMainVipPng from './main/vipButton/title_vip.png';
import BtnNavBackPng from './nav/btn_back.png';
import BtnNavBellPng from './nav/btn_bell.png';
import BtnNavChipPng from './nav/btn_chip.png';
//assets for profile modal
import NavMoreButton from './nav/btn_more.png';
import SoundOff from './nav/Btn_no_Sound_1.png';
import BtnNavOptionsPng from './nav/btn_options.png';
import SoundOn from './nav/Btn_volume.png';
import BtnLoginPng from './nav/login/btn_login.png';
import UserIconOutlinePng from './nav/login/user_icon_outline.png';
// assets for navigation bar
import NotificationBackgroundPng from './nav/notification_background.png';
import Num0Png from './numbers/0.png';
import Num1Png from './numbers/1.png';
import Num2Png from './numbers/2.png';
import Num3Png from './numbers/3.png';
import Num4Png from './numbers/4.png';
import Num5Png from './numbers/5.png';
import Num6Png from './numbers/6.png';
import Num7Png from './numbers/7.png';
import Num8Png from './numbers/8.png';
import Num9Png from './numbers/9.png';
import ChipCoinIcon from './popup/chip_coin.png';
import LoginEmail from './popup/emailLogin.png';
import GameRulesLight from './popup/gameRulesLight.png';
import GameRulesTitle from './popup/gameRulesTitle.png';
import HeaderGlow from './popup/header_glow.png';
import InviteBckd from './popup/invitebckd.png';
import InvitedPlayerBackground from './popup/invitedPlayerBackground.png';
import InviteNewPlayerPng from './popup/inviteNewPlayer.png';
import InvitePlus from './popup/invitePlus.png';
import LightLines from './popup/LightsLines.png';
import LoginBackground from './popup/loginModal.png';
import LoginTitle from './popup/loginTitle.png';
import MessagesPng from './popup/messages.png';
import ModalNotEnoughChipsBg from './popup/modal_not_enough_chips.png';
import ModalTitle from './popup/modalTitle.png';
import NotificationPng from './popup/notification.png';
import PersonalDataTitle from './popup/personalDataTitle.png';
import RecycleBin from './popup/recycle_bin.png';
import RedChipsPng from './popup/redChips.png';
import RulesBackground from './popup/rulesBckd.png';
import SettingsTitle from './popup/settingsTitle.png';
import ToggleBgPng from './popup/switchOnBtn.png';
import ToggleKnobPng from './popup/toggleKnob.png';
import ArrowDownPng from './profile/arrowDown.png';
import AvatarFramePng from './profile/avatarFrame/avatar_frame.png';
import AvatarFrameGradientBluePng from './profile/avatarFrame/avatar_frame_gradient_blue.png';
import AvatarFrameGradientGoldPng from './profile/avatarFrame/avatar_frame_gradient_gold.png';
import AvatarFrameGradientRedPng from './profile/avatarFrame/avatar_frame_gradient_red.png';
import AvatarFrameSparklePng from './profile/avatarFrame/avatar_frame_sparkle.png';
import {
	default as AvatarFrameVipPng,
	default as VipBadgeImage,
} from './profile/avatarFrame/avatar_frame_vip.png';
import AvatarModalPng from './profile/AvatarModal.png';
import BottomButtons from './profile/bottomBtns.png';
import BtnCloseModal from './profile/Btn_Close.png';
import BtnEditModal from './profile/btn_edit.png';
import BtnPhotoModal from './profile/Btn_Photo.png';
import buyNowChips from './profile/BuyChips/buyNowBtn.png';
import buyNowPink from './profile/BuyChips/buyNowPink.png';
import chipImgOne from './profile/BuyChips/chipImgOne.png';
import chipImgThree from './profile/BuyChips/chipImgThree.png';
import ChipsBackgrOne from './profile/BuyChips/ChipsBackgrOne.png';
import ChipsBackgrTwo from './profile/BuyChips/ChipsBackgrTwo.png';
import ChipsBackgrTwoLand from './profile/BuyChips/ChipsBackgrTwoLand.png';
import chipImgTwo from './profile/BuyChips/chipsImgTwo.png';
import ChipsBackgrOneLand from './profile/BuyChips/ChipsOneBackgrOneLand.png';
import goldChipIcon from './profile/BuyChips/goldChipIcon.png';
import VipBtnLights from './profile/BuyVip/btnLights.png';
import BuyBtn from './profile/BuyVip/buyNow.png';
import BuyVipBtn from './profile/BuyVip/buyNowBtn.png';
import SmallVipOne from './profile/BuyVip/smallVip1.png';
import SmallVipSix from './profile/BuyVip/smallVip6.png';
import SmallVipTwelve from './profile/BuyVip/smallVip12.png';
import VipOneImage from './profile/BuyVip/Vip1Image.png';
import VipSixImage from './profile/BuyVip/Vip6image.png';
import VipTwelveImage from './profile/BuyVip/Vip12image.png';
import VipBackground from './profile/BuyVip/vipBackground.png';
import VipBackgroundLandscape from './profile/BuyVip/vipBackgroundLandscape.png';
import { default as ChipPng, default as ProfileChipPng } from './profile/chip.png';
import ChipsTitle from './profile/chipsTitle.png';
import CircleBlue from './profile/circleBlue.png';
import CircleGold from './profile/circleGold.png';
import CircleGreen from './profile/circleGreen.png';
import DateLights from './profile/DateLights.png';
import { default as FacebookBtn, default as FacebookLogin } from './profile/FacebookBtn.png';
import FlagEnPng from './profile/flagEn.png';
import GoogleBtn from './profile/GoogleBtn.png';
import InputField from './profile/inputField.png';
import ProfileLevelFramePng from './profile/level/profile_level_frame.png';
import LightBtn from './profile/light.png';
import LightsHeader from './profile/lightsHeader.png';
import Login from './profile/login.png';
import LosesTitle from './profile/losesTitle.png';
import NamePng from './profile/Name.png';
import ProfileImage from './profile/profileImage.png';
import ProfileScore from './profile/profileScore.png';
import ProfileTitlePopup from './profile/profileTitlePopup.png';
import ProfileRegistration from './profile/registration_background.png';
import RegistrationTitle from './profile/registrationTitle.png';
import ReportPlayerIcon from './profile/report-player-icon.png';
import SaveBtn from './profile/saveBtn.png';
import SaveButton from './profile/saveButton.png';
import SearchTitlePng from './profile/searchTitlePopup.png';
import StarPng from './profile/star.png';
import StatisticsDownLightPng from './profile/statisticDownLight.png';
import StatisticsText from './profile/statisticsText.png';
import StatisticsUpLightPng from './profile/statisticsUpLight.png';
import TimerBackgroundPng from './profile/timerBackground.png';
import BronzeTrophee from './profile/tournaments/BronzeTrophee.png';
import FirstCup from './profile/tournaments/FirstCup.png';
import FirstBackground from './profile/tournaments/FirstPlaceBckd.png';
import GoldTrophee from './profile/tournaments/GoldTrophee.png';
import SecondCup from './profile/tournaments/SecondCup.png';
import SecondBackground from './profile/tournaments/SecondPlaceBckd.png';
import SilverLights from './profile/tournaments/silverLights.png';
import SilverTrophee from './profile/tournaments/SilverTrophee.png';
import ThirdCup from './profile/tournaments/ThirdCup.png';
import ThirdBackground from './profile/tournaments/ThirdPlaceBckd.png';
import TotalLights from './profile/tournaments/totalLights.png';
import UnderTitleLight from './profile/tournaments/underTitleLight.png';
import UsernameFramePng from './profile/username_frame.png';
import UsernameFrameDownLightPng from './profile/username_frame_down_light.png';
import VipBadgeFramePng from './profile/vip_badge_frame.png';
import WinsTitle from './profile/winsTitle.png';
import PlayerLogo from './ranking/PlayerLogo.png';
import Rank1Logo from './ranking/Rank1Logo.png';
import Rank2Logo from './ranking/Rank2Logo.png';
import Rank3Logo from './ranking/Rank3Logo.png';
import RankBgr1 from './ranking/RankBgr1.png';
import RankBgr2 from './ranking/RankBgr2.png';
import RankBgr3 from './ranking/RankBgr3.png';
import RankBgrRegular from './ranking/RankBgrRegular.png';
import RankChip from './ranking/RankChip.png';
import RankExp from './ranking/RankExp.png';
import RankingTabBtn from './ranking/RankingTabBtn.png';
import RankingTabBtnSelected from './ranking/RankingTabBtnSelected.png';
import RankLevelBorder from './ranking/RankLevelBorder.png';
import RankNameBorder from './ranking/RankNameBorder.png';
import RankPlayerLogoBorder from './ranking/RankPlayerLogoBorder.png';
import RankStarLight from './ranking/RankStarLight.png';
import Timer from './ranking/timer.png';
import RankingsBronzePng from './rankings/bronze.png';
import RankingsChipsPng from './rankings/chips.png';
import RankingsDiamondPng from './rankings/diamond.png';
import RankingsFirstPlacePng from './rankings/first-place.png';
import RankingsGoldPng from './rankings/gold.png';
// Figma "Hero / Rankings" (6895:117592) art, 3x the 368 wide mobile banner.
import RankingsHeroBannerJpg from './rankings/hero-banner.jpg';
// The same art at Figma's source size (1584 x 672) for the desktop banner (6919:117651), which is
// drawn up to ~1840 wide, past what the 1104 mobile cut holds.
import RankingsHeroBannerDesktopJpg from './rankings/hero-banner-desktop.jpg';
import RankingsPlatinumPng from './rankings/platinum.png';
import RankingsPointsPng from './rankings/points.png';
import RankingsRichestPng from './rankings/richest.png';
import RankingsSecondPlacePng from './rankings/second-place.png';
import RankingsSilverPng from './rankings/silver.png';
import RankingsStarPng from './rankings/star.png';
import RankingsThirdPlacePng from './rankings/third-place.png';
import RankingsTournamentsPng from './rankings/tournaments.png';
import BtnSidebarClosePng from './sidebar/btn_sidebar_close.png';
import * as SidebarAssets from './sidebar/content/index';
import SidebarBackgroundPng from './sidebar/sidebar__background.png';
import SidebarLeftLightPng from './sidebar/sidebar_left_light.png';
import SidebarSeparatorLightPng from './sidebar/sidebar_separator_light.png';
import SidebarTopLightPng from './sidebar/sidebar_top_light.png';
import TableLogo from './tables/table_logo.png';
import TableLogoBg from './tables/table_logo_bg.png';
import TableLogoFr from './tables/table_logo_fr.png';
import TableLogoru from './tables/table_logo_ru.png';
import ActiveTablesBtn from './tournaments/active_tables.png';
import ActiveTablesButton from './tournaments/activeTablesButton.png';
import BronzeButton from './tournaments/bronze_win.png';
import BronzeTournamentCard from './tournaments/bronzeTournamentCard.png';
import BlueButton from './tournaments/Btn.png';
import ButtonRegister from './tournaments/Btn_register.png';
import EntryInfoLight from './tournaments/entryLight.png';
import GoldButton from './tournaments/gold_btn.png';
import GoldTournamentCard from './tournaments/goldTournamentCard.png';
import LockedTournament from './tournaments/lockedTournament.png';
import mainLobbyBtn from './tournaments/mainBtn.png';
import mainLobbyBtnActive from './tournaments/mainBtnActive.png';
import mainLobbyBtnDesktop from './tournaments/mainBtnDesktop.png';
import MainBtnMobile from './tournaments/mainBtnMobile.png';
import RewardsBlueLight from './tournaments/rewardBlueLight.png';
import RewardsBronzeLight from './tournaments/rewardBronzeLight.png';
import { default as RewardChips, default as WinButtonCoins } from './tournaments/rewardChips.png';
import SignupBtn from './tournaments/SignupBtn.png';
import SilverTournamentCard from './tournaments/silverTournamentCard.png';
import TournamentChipsIcon from './tournaments/TournamentBlueChip.png';
import TournamentCardPlateBronze from './tournaments/tournamentCardPlateBronze.png';
import TournamentCardPlateGold from './tournaments/tournamentCardPlateGold.png';
import TournamentCardPlateSilver from './tournaments/tournamentCardPlateSilver.png';
import {
	default as RewardChipsIcon,
	default as TournamentsChipImg,
} from './tournaments/tournamentChip.png';
import TropheeGold from './tournaments/tournamentFirst.png';
import RewardsPurpleLight from './tournaments/tournamentPurpleLight.png';
import TropheeBronze from './tournaments/TournamentsThree.png';
import TropheeSilver from './tournaments/tournamentsTwo.png';
import TournamentWinCoins from './tournaments/tournamentWinCoins.png';
import EntryChipsIcon from './tournaments/TournamentYellowChip.png';
import TournamentsTrofeeGold from './tournaments/trophee_gold.png';
import TournamentsTrofeeBronze from './tournaments/trophee_icon_bronze.png';
import TournamentsTrofeeSilver from './tournaments/trophee_silver.png';
import WinButton from './tournaments/win_btn.png';
import VipActiveMemberActiveIcon from './vipActiveMember/active.svg';
import VipActiveMemberCalendar from './vipActiveMember/calendar.png';
import VipActiveMemberCardBack from './vipActiveMember/card-back.png';
import VipActiveMemberLoyaltyBadge from './vipActiveMember/loyalty-badge.png';
import VipActiveMemberLoyaltyReward from './vipActiveMember/loyalty-reward.png';
import VipActiveMemberProfileFrame from './vipActiveMember/profile-frame.png';
import VipActiveMemberSubscriptionSettings from './vipActiveMember/subscription-settings.png';
import VipActiveMemberWeeklyGift from './vipActiveMember/weekly-gift.png';
import VipSubscriptionBackground from './vipSubscription/background.png';
import VipSubscriptionBenefit1 from './vipSubscription/benefit-1.png';
import VipSubscriptionBenefit2 from './vipSubscription/benefit-2.png';
import VipSubscriptionBenefit3 from './vipSubscription/benefit-3.png';
import VipSubscriptionBenefit4 from './vipSubscription/benefit-4.png';
import VipSubscriptionBenefit5 from './vipSubscription/benefit-5.png';
import VipSubscriptionBenefit6 from './vipSubscription/benefit-6.png';
import VipSubscriptionBenefit7 from './vipSubscription/benefit-7.png';
import VipSubscriptionBenefit8 from './vipSubscription/benefit-8.png';
import VipSubscriptionBestValue from './vipSubscription/chips-best-value.png';
import VipSubscriptionCrown from './vipSubscription/crown.png';
import VipSubscriptionFeatureBenefits from './vipSubscription/feature-benefits.png';
import VipSubscriptionFeatureCardBack from './vipSubscription/feature-card-back.png';
import VipSubscriptionFeatureEventPass from './vipSubscription/feature-event-pass.png';
import VipSubscriptionFeatureFrame from './vipSubscription/feature-frame.png';
import VipSubscriptionHeroLogo from './vipSubscription/hero-logo.png';
import VipSubscriptionLoyalty from './vipSubscription/loyalty.png';
import VipSubscriptionMonthly from './vipSubscription/montly.png';
import VipSubscriptionReward1 from './vipSubscription/reward-1.png';
import VipSubscriptionReward2 from './vipSubscription/reward-2.png';
import VipSubscriptionReward3 from './vipSubscription/reward-3.png';
import VipSubscriptionReward4 from './vipSubscription/reward-4.png';
import VipSubscriptionSparkle from './vipSubscription/sparkle.png';
import VipSubscriptionTopGlow from './vipSubscription/top-glow.png';
import VipSubscriptionWeekly from './vipSubscription/weekly.png';
import VipSubscriptionWelcome from './vipSubscription/welcome.png';

export {
	ActiveTablesBtn,
	ActiveTablesButton,
	AdsModalBackground,
	AdsModalChips,
	AdsModalWatchButton,
	AppleButton,
	ArrowDownPng,
	AvatarFrameGradientBluePng,
	AvatarFrameGradientGoldPng,
	AvatarFrameGradientRedPng,
	AvatarFramePng,
	AvatarFrameSparklePng,
	AvatarFrameVipPng,
	AvatarModalPng,
	PlayerIconPng,
	BGCollectBtn,
	BGCollectBtnMobile,
	BGCollectBtnWrapper,
	BGCurrentDayFrame,
	BGCurrentDayFrameMobile,
	BgFlag,
	BGHorDivider,
	BGHorDividerAndTrMobile,
	BGHorDividerMobile,
	BgLandscapePng,
	BGPlayBtn,
	BgPortraitPng,
	BGRegularDayFrame,
	BGRorB,
	BGRorB_Thumb,
	BGScratch,
	BGScratch_Thumb,
	BGSlot,
	BGSlot_Thumb,
	BGTimerWrapper,
	BgTournament,
	BgTournamentMobile,
	BGVertDividerMobile,
	BlueButton,
	BlueTable,
	BonusBgPng,
	BonusBgPortraitPng,
	BonusesHover,
	BonusGamesModalDays,
	BonusGInfoBtn,
	BonusGJackpot,
	BonusGLogo,
	BonusRedBlackGif,
	BonusScratchGif,
	BonusSlotGif,
	BottomButtons,
	BottomJackpot,
	BottomLightDownPng,
	BottomLightUpPng,
	BottomlPng,
	BottomPng,
	BottomStripPng,
	BottomStripRightPng,
	BronzeButton,
	BronzeTournamentCard,
	BronzeTrophee,
	BtnBonuses,
	BtnBottomBonusesCollectLightPng,
	BtnBottomBonusesCollectPng,
	BtnBottomBonusesPng,
	BtnBottomLobbyPng,
	BtnBottomRankingPng,
	BtnCloseModal,
	BtnEditModal,
	BtnLobby,
	BtnLoginPng,
	BtnMainBackground,
	BtnMainPlayNowPng,
	BtnMainTournamentsPng,
	BtnMainVipPng,
	BtnNavBackPng,
	BtnNavBellPng,
	BtnNavChipPng,
	BtnNavOptionsPng,
	BtnPhotoModal,
	BtnRanking,
	BtnSidebarClosePng,
	ButtonRegister,
	BuyBtn,
	buyNowChips,
	buyNowPink,
	BuyVipBtn,
	ChipCoinIcon,
	chipImgOne,
	chipImgThree,
	chipImgTwo,
	ChipPng,
	ChipsBackgrOne,
	ChipsBackgrOneLand,
	ChipsBackgrTwo,
	ChipsBackgrTwoLand,
	ChipsTitle,
	CircleBlue,
	CircleGold,
	CircleGreen,
	CityBackground,
	CityPng,
	DailyBonusBgGif,
	DailyBonusEnGif,
	DailyBonusFrGif,
	DailyBonusRuGif,
	DailyBonusTextBgPng,
	DailyBonusTextEnPng,
	DailyBonusTextFrPng,
	DailyBonusTextRuPng,
	DateLights,
	EnFlag,
	EntryChipsIcon,
	EntryInfoLight,
	FacebookBtn,
	FacebookButton,
	FacebookLogin,
	FirstBackground,
	FirstCup,
	FlagEnPng,
	FrFlag,
	GameRulesLight,
	GameRulesTitle,
	GoldButton,
	goldChipIcon,
	GoldTournamentCard,
	GoldTrophee,
	GoogleBtn,
	GoogleButton,
	HeaderGlow,
	HorizontalLoginBg,
	InputField,
	InviteBckd,
	InvitedPlayerBackground,
	InviteNewPlayerPng,
	InvitePlus,
	JackpotCoin,
	JackpotChipPng,
	JackpotCoins,
	JackpotHistory,
	LanguageCaret,
	LanguageCaretUp,
	CarouselCardBgPng,
	CarouselCardGlowPng,
	LeftArrowPng,
	LightBtn,
	LightLines,
	LightsHeader,
	LightsLevels,
	LobbyTableChip,
	LockedTournament,
	Login,
	LoginBackground,
	LoginEmail,
	LoginTitle,
	LogoAnimation,
	LogoPng,
	LondonPng,
	LosesTitle,
	MacaoPng,
	MainBtnMobile,
	mainLobbyBtn,
	mainLobbyBtnActive,
	mainLobbyBtnDesktop,
	MainUserIcon,
	MainUsersLiveFramePng,
	MessagesPng,
	ModalNotEnoughChipsBg,
	ModalTitle,
	MonacoPng,
	MyTablesButtonBg,
	NamePng,
	NavMoreButton,
	NotificationBackgroundPng,
	NotificationPng,
	Num0Png,
	Num1Png,
	Num2Png,
	Num3Png,
	Num4Png,
	Num5Png,
	Num6Png,
	Num7Png,
	Num8Png,
	Num9Png,
	ParisPng,
	PersonalDataTitle,
	PlayerGold,
	PlayerGrey,
	PlayerLogo,
	PortraitLoginBg,
	ProfileChipPng,
	ProfileImage,
	ProfileLevelFramePng,
	ProfileRegistration,
	ProfileScore,
	ProfileTitlePopup,
	Rank1Logo,
	Rank2Logo,
	Rank3Logo,
	RankBgr1,
	RankBgr2,
	RankBgr3,
	RankBgrRegular,
	RankChip,
	RankExp,
	RankingTabBtn,
	RankingTabBtnSelected,
	RankLevelBorder,
	RankNameBorder,
	RankPlayerLogoBorder,
	RankStarLight,
	RankingsBronzePng,
	RankingsChipsPng,
	RankingsDiamondPng,
	RankingsFirstPlacePng,
	RankingsGoldPng,
	RankingsHeroBannerDesktopJpg,
	RankingsHeroBannerJpg,
	RankingsPlatinumPng,
	RankingsPointsPng,
	RankingsRichestPng,
	RankingsSecondPlacePng,
	RankingsSilverPng,
	RankingsStarPng,
	RankingsThirdPlacePng,
	RankingsTournamentsPng,
	RecycleBin,
	RedChipsPng,
	RegistrationTitle,
	ReportPlayerIcon,
	RewardChips,
	RewardChipsIcon,
	RewardsBlueLight,
	RewardsBronzeLight,
	RewardsPurpleLight,
	RightArrowPng,
	RuFlag,
	RulesBackground,
	SaveBtn,
	SaveButton,
	SearchTitlePng,
	SecondBackground,
	SecondCup,
	SettingsTitle,
	SidebarAssets,
	SidebarBackgroundPng,
	SidebarLeftLightPng,
	SidebarSeparatorLightPng,
	SidebarTopLightPng,
	SignupBtn,
	SilverLights,
	SilverTournamentCard,
	SilverTrophee,
	SmallVipOne,
	SmallVipSix,
	SmallVipTwelve,
	SofiaPng,
	SoundOff,
	SoundOn,
	StarPng,
	StatisticsDownLightPng,
	StatisticsText,
	StatisticsUpLightPng,
	Table,
	TableLogo,
	TableLogoBg,
	TableLogoFr,
	TableLogoru,
	TablesContainerPng,
	ThirdBackground,
	ThirdCup,
	Timer,
	TimerBackgroundPng,
	TitleMainPlayNowPng,
	TitleMainTournamentsPng,
	TitleMainVipPng,
	ToggleBgPng,
	ToggleKnobPng,
	TotalLights,
	TournamentCardPlateBronze,
	TournamentCardPlateGold,
	TournamentCardPlateSilver,
	TournamentChipsIcon,
	TournamentsButtonBg,
	TournamentsChipImg,
	TournamentsTrofeeBronze,
	TournamentsTrofeeGold,
	TournamentsTrofeeSilver,
	TournamentWinCoins,
	TrFlag,
	TropheeBronze,
	TropheeGold,
	TropheeSilver,
	UnderTitleLight,
	UserIconOutlinePng,
	UsernameFrameDownLightPng,
	UsernameFramePng,
	VegasPng,
	VipBackground,
	VipBackgroundLandscape,
	VipBadgeFramePng,
	VipBadgeImage,
	VipActiveMemberActiveIcon,
	VipActiveMemberCalendar,
	VipActiveMemberCardBack,
	VipActiveMemberLoyaltyBadge,
	VipActiveMemberLoyaltyReward,
	VipActiveMemberProfileFrame,
	VipActiveMemberSubscriptionSettings,
	VipActiveMemberWeeklyGift,
	VipBtnLights,
	VipOneImage,
	VipPng,
	VipSixImage,
	VipSubscriptionBenefit1,
	VipSubscriptionBenefit2,
	VipSubscriptionBenefit3,
	VipSubscriptionBenefit4,
	VipSubscriptionBenefit5,
	VipSubscriptionBenefit6,
	VipSubscriptionBenefit7,
	VipSubscriptionBenefit8,
	VipSubscriptionBackground,
	VipSubscriptionBestValue,
	VipSubscriptionCrown,
	VipSubscriptionFeatureBenefits,
	VipSubscriptionFeatureCardBack,
	VipSubscriptionFeatureEventPass,
	VipSubscriptionFeatureFrame,
	VipSubscriptionHeroLogo,
	VipSubscriptionLoyalty,
	VipSubscriptionMonthly,
	VipSubscriptionReward1,
	VipSubscriptionReward2,
	VipSubscriptionReward3,
	VipSubscriptionReward4,
	VipSubscriptionSparkle,
	VipSubscriptionTopGlow,
	VipSubscriptionWeekly,
	VipSubscriptionWelcome,
	VipTwelveImage,
	WatchAddsButton,
	WinButton,
	WinButtonCoins,
	WinsTitle,
};

const BonusGamesModalDays = {
	1: BGDay1,
	2: BGDay2,
	3: BGDay3,
	4: BGDay4,
	5: BGDay5,
};
